// extracted by mini-css-extract-plugin
export default {"prevArrow":"news_prevArrow__94WLa","nextArrow":"news_nextArrow__k7xMu","tab":"news_tab__Kj7iQ"};